import { createBrowserHistory, History } from 'history'
import { AnyAction, CombinedState, combineReducers } from 'redux'
import { HistoryLocationState } from '../types/history'
import { configureStore, Reducer } from '@reduxjs/toolkit'
import { ThunkAction } from 'redux-thunk'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import systemConfigReducer from './reducers/systemConfig/reducers'
import { SystemConfig } from '../types/systemConfig'
import localeReducer from './reducers/locale/reducers'
import { ILocaleStore } from '../types/locale'
import { appReducer } from './reducers'
import { AppState, RootReducerState } from '../types/rootStoreTypes'
import authReducer from './reducers/auth/reducers'
import viewportReducer from './reducers/viewport/reducers'
import { IAuthState } from '../types/auth'
import { ViewportState } from '../types/viewport'

export const history: History<HistoryLocationState> = createBrowserHistory()

const combinedReducers = combineReducers<RootReducerState>({
	router: connectRouter(history) as unknown as Reducer<
		History<HistoryLocationState>
	>,
	systemConfig: systemConfigReducer as Reducer<SystemConfig>,
	locale: localeReducer as Reducer<ILocaleStore>,
	auth: authReducer as Reducer<IAuthState>,
	appReducer: appReducer as Reducer<AppState | Partial<AppState>>,
	viewport: viewportReducer as Reducer<ViewportState>,
})

const rootReducer = (
	state: RootReducerState,
	action: AnyAction
): CombinedState<RootReducerState> => {
	return combinedReducers(state, action)
}

export const store = configureStore({
	reducer: rootReducer as Reducer<CombinedState<RootReducerState>>,
	devTools: process.env.NODE_ENV !== 'production',
	middleware: getDefaultMiddleware => {
		return getDefaultMiddleware({
			serializableCheck: false,
		}).concat(routerMiddleware(history))
	},
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export type AppThunkAction<
	ReturnType = void,
	ActionType extends AnyAction = AnyAction
> = ThunkAction<ReturnType, RootState, unknown, ActionType>
